import React, { useEffect, useState } from 'react';
import { EmbeddedSnackbarContainer } from './embeddedSnackbar.style';
import { ALERT_BLACK_ICON } from '@Images';

type Type = 'warning' | 'success' | 'error';

const EmbeddedSnackbar: React.FC<{
  type: Type;
  message: string;
  timer?: number;
  show: boolean;
  className?: string;
  timerEndCallbackFn?: () => void;
}> = ({ type, message, timer = 4000, show, className = '', timerEndCallbackFn }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    open &&
      setTimeout(() => {
        setOpen(false);
        timerEndCallbackFn && timerEndCallbackFn();
      }, timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  return (
    <EmbeddedSnackbarContainer className={`${type} ${open && 'show-snackbar'} ${className}`}>
      <img src={ALERT_BLACK_ICON} alt="alert" />
      <p id="snackbar-alert">{message}</p>
    </EmbeddedSnackbarContainer>
  );
};
export default EmbeddedSnackbar;
